import React from 'react';
import { Globe, ChevronDown, MapPin } from 'lucide-react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '../ui/dropdown-menu';
import { useApp } from '../../context/AppContext';
import { LANGUAGES } from '../../lib/i18n';
import { COUNTRIES, CURRENCIES } from '../../data/constants';

const triggerCls = 'flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-sm font-medium text-[#3F3A30] hover:bg-[#FAF7F2] transition-colors';

export const LocaleControls = () => {
  const { lang, setLang, currency, setCurrency, country, setCountry } = useApp();
  const currentCountry = COUNTRIES.find((c) => c.code === country) || COUNTRIES[0];
  const currentLang = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button className={triggerCls} data-testid="country-selector">
            <MapPin className="w-3.5 h-3.5" /><span>{currentCountry.flag} {currentCountry.code}</span><ChevronDown className="w-3 h-3 opacity-60" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="max-h-80 overflow-y-auto">
          {COUNTRIES.map((c) => (
            <DropdownMenuItem key={c.code} data-testid={`country-option-${c.code}`} onClick={() => { setCountry(c.code); setCurrency(c.currency); }}>
              <span className="mr-2">{c.flag}</span>{c.name}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button className={triggerCls} data-testid="currency-selector">{CURRENCIES[currency]?.symbol} {currency}<ChevronDown className="w-3 h-3 opacity-60" /></button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          {Object.keys(CURRENCIES).map((c) => (
            <DropdownMenuItem key={c} data-testid={`currency-option-${c}`} onClick={() => setCurrency(c)}>
              <span className="font-mono w-10">{CURRENCIES[c].symbol}</span> {c}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button className={triggerCls} data-testid="language-selector"><Globe className="w-3.5 h-3.5" /><span className="uppercase">{currentLang.code}</span></button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          {LANGUAGES.map((l) => (
            <DropdownMenuItem key={l.code} data-testid={`language-option-${l.code}`} onClick={() => setLang(l.code)}>
              <span className="mr-2">{l.flag}</span>{l.label}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
};
